import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { ProviderShell } from "@/components/provider/ProviderShell";
import { HandoffBanner } from "@/components/provider/HandoffBanner";

export default function ProviderHomePage() {
  const [home, setHome] = useState(null);
  const [error, setError] = useState("");
  function load() {
    api.get("/providers/me/home").then((response) => setHome(response.data)).catch((requestError) => setError(formatApiError(requestError)));
  }
  useEffect(() => {
    load();
  }, []);
  return (
    <ProviderShell testId="provider-home-page">
      {error && <p className="form-message error-message" data-testid="provider-home-error">{error}</p>}
      {!home && !error && <p className="projection-loading">Loading…</p>}
      {home && (
        <>
          <section className="provider-greeting" data-testid="provider-greeting">
            <p className="eyebrow">{home.today_label.toUpperCase()}</p>
            <h1>Good {new Date().getHours() < 12 ? "morning" : new Date().getHours() < 17 ? "afternoon" : "evening"}, {home.greeting_name}</h1>
          </section>
          <HandoffBanner handoffs={home.handoffs} onChanged={load} onError={setError} />
          <section className="provider-next-step" data-testid="provider-next-step">
            <p className="eyebrow">YOUR NEXT STEP</p>
            {home.assignments_to_confirm?.length ? (
              <>
                <h2>{home.assignments_to_confirm[0].title}</h2>
                <p>{home.assignments_to_confirm[0].meta}</p>
                <Link className="primary-button" data-testid="provider-confirm-assignment-open" to={`/provider-portal/assignments/${home.assignments_to_confirm[0].id}`}>Open assignment</Link>
              </>
            ) : home.next_step ? (
              <>
                <h2>{home.next_step.title}</h2>
                <p>{home.next_step.meta}</p>
                <Link className="primary-button" data-testid="provider-next-step-open" to={`/provider-portal/work/${home.next_step.item_id}`}>Open {home.next_step.kind_word}</Link>
              </>
            ) : (
              <>
                <h2>You’re all caught up</h2>
                <p>Nothing is waiting on you right now.</p>
              </>
            )}
          </section>
          <section className="provider-counts" data-testid="provider-counts">
            <div><strong>{home.counts.due_this_week}</strong><span>Due this week</span></div>
            <div><strong>{home.counts.overdue}</strong><span>Overdue</span></div>
            <div><strong>{home.counts.schools}</strong><span>Schools</span></div>
          </section>
          <section className="provider-week" data-testid="provider-this-week">
            <div className="work-group-head"><h2>This week</h2><Link data-testid="provider-see-all" to="/provider-portal/work">See all</Link></div>
            {home.this_week.length === 0 && home.reminders.length === 0 && <p className="muted">Nothing due this week.</p>}
            {home.this_week.map((item) => (
              <Link key={item.id} className="provider-week-item" data-testid={`provider-week-${item.id}`} to={`/provider-portal/work/${item.id}`}>
                <div><strong>{item.title}</strong><span>{item.meta}</span></div>
                <em>{item.stage}</em>
              </Link>
            ))}
            {home.reminders.map((item) => (
              <div key={item.title} className="provider-week-item reminder" data-testid="provider-week-reminder">
                <div><strong>{item.title}</strong><span>{item.meta}</span></div>
                <em>{item.stage}</em>
              </div>
            ))}
          </section>
        </>
      )}
    </ProviderShell>
  );
}
